import { Fragment, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useHistory } from "react-router-dom";
import { completePurchase, cancelPurchase, voucherReservation } from "../../app/voucherSlice";
import Loading from "../../components/Loading/Loading";
import AcceptanceTutorial from "../../components/AcceptanceTutorial/AcceptanceTutorial";
import ConfirmationModal from "./ConfirmationModal";
import { useTranslation } from "react-i18next";

const SendingRequest = () => {
    const { t } = useTranslation();

    const chosenPaymentId = useAppSelector(state => state.voucher.chosenPaymentId);
    const dispatch = useAppDispatch();
    const history = useHistory();
    const [modalIsShowing, setModalIsShowing] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const purchaseIsCanceled = useAppSelector(state => state.voucher.purchaseCompleted.result);

    const onBackPage = (event: any) => {
        event.preventDefault();
        setModalIsShowing(true);
        window.history.pushState(null, "", window.location.pathname);
    };

    const onChangePage = (event: any) => {
        event.preventDefault();
        dispatch(completePurchase({ completed: false, result: "canceled" }))
        dispatch(cancelPurchase({ paymentId: chosenPaymentId }));
        dispatch(voucherReservation(""));
        history.replace('/');
        return null;
    }

    const sendCancelRequest = () => {
        dispatch(completePurchase({ completed: false, result: "canceled" }))
        setIsLoading(true);
        if (chosenPaymentId.length > 0) {
            dispatch(cancelPurchase({ paymentId: chosenPaymentId }));
            setIsLoading(false);
            dispatch(voucherReservation(""));
            history.replace('/');
        }
        
    }

    const hideModal = () => {
        setModalIsShowing(false);
    }

    useEffect(() => {
        if (purchaseIsCanceled === 'canceled') {
            sendCancelRequest()
        };
        window.history.pushState(null, "", window.location.pathname);
        window.addEventListener('popstate', onBackPage);
        window.addEventListener('beforeunload', onChangePage, { capture: true });
        
        return () => {
            window.removeEventListener('beforeunload', onChangePage, { capture: true });
            window.removeEventListener('popstate', onBackPage);

        }

    }, [chosenPaymentId, purchaseIsCanceled]);

    return (
        <Fragment>
            {modalIsShowing && <ConfirmationModal onStay={hideModal} onCancel={sendCancelRequest} isLoading={ isLoading }/>}
            <Loading content={t("result.sending")} />
            <AcceptanceTutorial />
        </Fragment>
    );
};

export default SendingRequest;
